import "@app/styles/theme/mapping/dit-components-mapping.scss";
import "@app/styles/theme/mapping/dit-layout-mapping.scss";
import "@app/styles/theme/mapping/dit-brand-mapping.scss";

import { CheckboxStyles } from "@app/components/elements/form/Checkbox.styles";
import { DialogStyles } from "@app/styles/DialogStyles";
import { blueprintStyles } from "@app/styles/blueprint";
import { cardStyles } from "@app/styles/cardStyles";
import { createGlobalStyle } from "styled-components";
import { drawerStyle } from "@app/styles/drawerStyle";
import { fontIcon } from "@app/styles/fonts/icon";
import { fonts } from "@app/styles/fonts";
import { headings } from "@app/styles/headings";
import { helpers } from "@app/styles/helpers/classes";
import { popoverStyle } from "@app/styles/popoverStyle";
import { reset } from "@app/styles/helpers/reset";
import { screenReader } from "@app/styles/helpers/screenReader";
import { tabStyle } from "@app/styles/tabStyle";
import { tokens } from "@app/styles/theme/tokens";
import { tooltipStyle } from "./tooltipStyle";

// CSS layers ensure cascade order is predictable regardless of render timing
// layer priority (lowest to highest): reset, vendors, base, tokens, components, overrides
export const GlobalStyle = createGlobalStyle`
    @layer base {
        body {
        	font-family: var(--dit-brand-font-family-primary--map);
        	font-size: var(--dit-brand-font-size-sm--map);
        	line-height: var(--dit-brand-font-line-height-normal--map);
        	color: var(--dit-layout-color-text-default--map);
        	background-color: var(--dit-layout-color-body-background--map);
        	overflow-x: hidden;
        }

        ${fonts}
        ${fontIcon}
        ${headings}
        ${helpers}
        ${screenReader}
        ${reset}
    }

    @layer tokens {
        ${tokens}
    }

    @layer overrides {
        ${blueprintStyles}
        ${tabStyle}
        ${popoverStyle}
        ${drawerStyle}
        ${DialogStyles}
        ${cardStyles}
        ${tooltipStyle}
        ${CheckboxStyles}
    }
`;
